// 数据验证工具函数

/**
 * 验证用户ID
 * @param {string} userId - 用户ID
 * @returns {boolean} 是否有效
 */
export const validateUserId = (userId) => {
  if (!userId || typeof userId !== 'string') {
    return false;
  }
  
  // 用户ID应该非空且长度在1-50之间
  return userId.trim().length > 0 && userId.trim().length <= 50;
};

/**
 * 验证数量
 * @param {number} count - 数量
 * @returns {boolean} 是否有效
 */
export const validateCount = (count) => {
  // 数量应该是非负整数
  return Number.isInteger(count) && count >= 0;
};

/**
 * 验证日期
 * @param {string} date - 日期字符串 (YYYY-MM-DD格式)
 * @returns {boolean} 是否有效
 */
export const validateDate = (date) => {
  if (!date || typeof date !== 'string') {
    return false;
  }
  
  // 检查格式是否为 YYYY-MM-DD
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(date)) {
    return false;
  }
  
  // 检查日期是否有效
  const parsedDate = new Date(date);
  return parsedDate.toISOString().slice(0, 10) === date;
};

/**
 * 验证补录数据
 * @param {Object} data - 补录数据
 * @returns {Object} 验证结果 { isValid: boolean, errors: string[] }
 */
export const validateBackfillData = (data) => {
  const errors = [];
  
  if (!data) {
    return { isValid: false, errors: ['数据不能为空'] };
  }
  
  // 验证日期
  if (!validateDate(data.date)) {
    errors.push('日期格式无效');
  }
  
  // 验证数量
  if (!validateCount(data.count)) {
    errors.push('数量必须是非负整数');
  }
  
  return {
    isValid: errors.length === 0,
    errors
  };
};